import { createSlice, createDraftSafeSelector, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchCanvasImage = createAsyncThunk('canvas/fetchCanvasImage', async data => {
  try {
    const { captureImage } = data;
    let filePath = new URL(captureImage);
    filePath = filePath.pathname.substring(1);
    return { captureImage: filePath };
  } catch (err) {
    throw err.response?.data?.error || err;
  }
});

export const fetchSaveImage = createAsyncThunk('canvas/fetchSaveImage', async data => {
  try {
    const { saveImage } = data;
    return { saveImage: saveImage };
  } catch (err) {
    throw err.response?.data?.error || err;
  }
});

const initialState = {
  captureImage: '',
  saveImage: '',
};

const reducers = {};

const extraReducers = {
  [fetchCanvasImage.fulfilled]: (state, action) => {
    state.captureImage = action.payload;
  },
  [fetchSaveImage.fulfilled]: (state, action) => {
    state.saveImage = action.payload;
  },
};

export const canvas = createSlice({
  name: 'canvas',
  initialState,
  reducers: reducers,
  extraReducers: extraReducers,
});

export const CANVAS = canvas.name;
export const canvasReducer = canvas.reducer; /* reducer */

/* create selector */
const selectCaptureImage = createDraftSafeSelector(
  state => state.captureImage,
  captureImage => ({
    captureImage,
  })
);
const selectSaveImage = createDraftSafeSelector(
  state => state.saveImage,
  saveImage => ({
    saveImage,
  })
);

export const canvasSelector = {
  captureImageState: state => selectCaptureImage(state[CANVAS]),
  saveImageState: state => selectSaveImage(state[CANVAS]),
};
